import * as v from "valibot";

import { rpcContract } from "../rpc";

export const adminBrandsRpcContract = rpcContract({
  name: "adminBrands",
  paramsSchema: v.object({
    limit: v.pipe(v.optional(v.number(), 25), v.minValue(1), v.maxValue(50)),
    offset: v.pipe(v.optional(v.number(), 0), v.minValue(0)),
    search: v.optional(v.string()),
    sortBy: v.optional(v.picklist(["name", "postsCount", "discountsCount", "trendsCount", "created"])),
    sortOrder: v.optional(v.picklist(["asc", "desc"])),
  }),
  resultSchema: v.object({
    brands: v.array(
      v.object({
        id: v.string(),
        name: v.string(),
        thumbnail: v.nullable(v.string()),
        hasMetaPixel: v.boolean(),
        postsCount: v.number(),
        discountsCount: v.number(),
        trendsCount: v.number(),
        created: v.string(), // ISO date string
        fileId: v.nullable(v.string()),
        filePath: v.nullable(v.string()),
      }),
    ),
    totalCount: v.number(),
  }),
});

export type AdminBrandsParams = v.InferOutput<(typeof adminBrandsRpcContract)["paramsSchema"]>;
export type AdminBrandsResult = v.InferOutput<(typeof adminBrandsRpcContract)["resultSchema"]>;
export type AdminBrand = v.InferOutput<(typeof adminBrandsRpcContract)["resultSchema"]>["brands"][0];
